import { defineComponent } from 'vue'

import { MediaTransferHelper } from '@skinsoft/media-transfer-helper'
import { reactiveVueMixin } from "@skinsoft/reactive-vue"
import { DeleteImageClickEvent, ImageClickEvent, MediaArea } from '@skinsoft/entity-ui/src/media/medias-area'
import { DELETE_IMAGE_CLICK_TOPIC, IMAGE_CLICK_TOPIC, IMAGE_UPLOADED_TOPIC, MEDIA_END_LOADING_TOPIC, MEDIA_ID_CHANGED_FROM_CACHE, PRINCIPAL_IMAGE_CLICK_TOPIC } from '@skinsoft/bus/src/busTopics'
import { OPEN_DRAWING_EDITOR_TOPIC } from "../../../busTopics"

export default defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sMediaArea: MediaArea
    },
    props: ['associatedMedias', 'alterations', 'readOnly'],
    template: require('./condition-report-medias-area.html'),
    data() {
        return {
            mediasToDisplay: [] as string[],
            mediaUploadInProgress: false,
            clickOnMediasAllowed: true,

            DELETE_IMAGE_CLICK_TOPIC: DELETE_IMAGE_CLICK_TOPIC,
            IMAGE_UPLOADED_TOPIC: IMAGE_UPLOADED_TOPIC,
            PRINCIPAL_IMAGE_CLICK_TOPIC: PRINCIPAL_IMAGE_CLICK_TOPIC,
            MEDIA_ID_CHANGED_FROM_CACHE: MEDIA_ID_CHANGED_FROM_CACHE,
            IMAGE_CLICK_TOPIC: IMAGE_CLICK_TOPIC,
        }
    },
    mounted() {
        this.computeMediasToDisplay()
        this.subscribeToBus(MEDIA_END_LOADING_TOPIC, (message => {
                this.clickOnMediasAllowed = true
        }))
    },
    methods: {
        computeMediasToDisplay() {
            if(this.associatedMedias) {
                // we only add medias that are not present in the array to avoid changing position of the newly added medias in the array
                // this can occur because we notify the parent that a new media has been uploaded only after having uploaded it on server
                const newMedias = this.associatedMedias.filter(mediaId => !this.mediasToDisplay.includes(mediaId))
                this.mediasToDisplay = this.mediasToDisplay.concat(newMedias)
            }

            return []
        },

        onImageClick(event: ImageClickEvent) {
            if(this.clickOnMediasAllowed) {
                this.emitOnBus(OPEN_DRAWING_EDITOR_TOPIC, event.id)
            }
        },

        onImageDeleteClick(event: DeleteImageClickEvent) {
            if (this.mediasToDisplay) {
                const removedMediaId = this.mediasToDisplay.splice(event.imageListIndex, 1)
                event.imageId = removedMediaId[0]
            }
            this.$emit(DELETE_IMAGE_CLICK_TOPIC, event)
        },

        async uploadMedia(fileData) {
            this.clickOnMediasAllowed = false
            const formData = new FormData()
            formData.append("file", fileData.file)

            this.mediaUploadInProgress = true
            // Retrieving temp id and uploading the media on backend asynchronously
            let cacheKey = ''
            if(window.navigator.onLine) {
                cacheKey = (this as any).$imageTransferHelper.uploadImage(fileData.file.type, fileData.file, fileData.url).cacheKey
            }
            else {
                cacheKey = (this as any).$imageTransferHelper.uploadImageInCache(fileData.file, fileData.url)
            }
            setTimeout(() => { // if no timeout, the DOM may not have the time to update
                this.mediaUploadInProgress = false
            }, 500)

            this.mediasToDisplay.push(cacheKey)

            if(window.navigator.onLine) {
                const fileName = cacheKey.split(':')
                if(fileName) {
                    const mediaTransferHelper = MediaTransferHelper.getInstance()

                    const newMedia = await mediaTransferHelper.repeatFindingMediaIdFromFileName(cacheKey.split(':')[1])

                    // updating id in local list (to avoid media changing position in array)
                    const mediaIndex = this.mediasToDisplay.indexOf(cacheKey)
                    this.mediasToDisplay[mediaIndex] = newMedia.id

                    if(newMedia?.id) {
                        mediaTransferHelper.saveMappingCacheKeyMediaId(cacheKey, newMedia.id)
                    }

                    ;(this as any).$imageTransferHelper.addImageToReporterSubAlbum(newMedia.id)
                    this.$emit('addMedia', {cacheKey: cacheKey, newMediaId: newMedia.id})
                    return
                }
            }

            this.$emit('addMedia', { cacheKey: cacheKey })
        },
    },
    watch: {
        associatedMedias: {
            handler() {
                this.computeMediasToDisplay()
            },
            deep: true,
        },
        alteration: {
            handler() {
                this.computeMediasToDisplay()
            },
            deep: true,
        },
    },
})
